import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface HeaderWrapperProps {
  isFixed?: boolean;
  children?: ReactNode;
}

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  position: relative;
  color: ${({ theme }) => theme.palette.text.secondary};
  background-color: ${({ theme }) => theme.colors.header};
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  height: 51px;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }

  ${({ isFixed }) =>
    isFixed &&
    css`
      position: fixed;
      width: 100%;
      z-index: 2;
      top: 0;
    `}
`;

interface SearchWrapperProps {
  isSearchFocus?: boolean;
  children?: ReactNode;
}

export const SearchWrapper = styled.div<SearchWrapperProps>`
  display: flex;
  height: fit-content;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  padding-left: 1vw;
  padding-right: 1vw;
  height: 100%;
  font-size: ${({ theme }) => theme.fonts.headerNav || 'inherit'};

  ${({ isSearchFocus }) =>
    isSearchFocus &&
    css`
      position: absolute;
      left: 160px;
      background-color: ${({ theme }) => theme.colors.header};
    `}

  @media (min-width: 768px) {
    border-left: ${({ theme }) => `1px solid ${theme.palette.backgrounds.main}`};
  }

  @media (max-width: 767px) {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 10px;
    border-top: ${({ theme }) => `1px solid ${theme.palette.backgrounds.main}`};
    min-width: 70%;
  }
`;

interface StyledDivProps {
  children?: ReactNode;
}

export const LeftNavWrapper = styled.div<StyledDivProps>`
  display: flex;
  justify-content: flex-end;
  height: auto;
  align-items: stretch;
  flex-wrap: nowrap;
  width: 100%;
`;
